import React from "react";
import Script from "next/script";

import { STATUS } from "./lib";

const CookieConsent = () => (
  <>
    <Script
      src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
      type="text/javascript"
      charSet="UTF-8"
      data-domain-script={process.env.NEXT_PUBLIC_ONETRUST_DATA_DOMAIN}
      id="consent-script"
    />
    <Script type="text/javascript">{`function OptanonWrapper() {
      const status = document.getElementById("onetrust-accept-btn-handler") ? '${STATUS.WAITING_FOR_CONSENT}' : '${STATUS.EXPRESSED_CONSENT}';
      
      window.top.postMessage(status, '*');
    }`}</Script>
  </>
);

export default CookieConsent;
